import { render } from "./bathroomSpace.vue?vue&type=template&id=2e6068e6&scoped=true"
import script from "./bathroomSpace.vue?vue&type=script&lang=js"
export * from "./bathroomSpace.vue?vue&type=script&lang=js"

import "./bathroomSpace.vue?vue&type=style&index=0&id=2e6068e6&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6068e6"]])

export default __exports__